import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import MainLayout from "../../../components/layout/MainLayout";
import ProgressNoteForm from "../ProgressNote/ProgressNoteForm";
import { createProgressNote } from "../../../store/slices/progressNotesSlice";

const AddProgressNote = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { state } = useLocation();
    const { caseId, patientId, type_id } = state || {}; // ✅ Get type_id from navigation state

    const { isLoading } = useSelector((state) => state.progressNotes);

    const [formData, setFormData] = useState({
        patientId,
        caseId,
        type_id: type_id || null, // ✅ NEW: Store type_id
        progressNotes: [],
    });

    const [errors, setErrors] = useState({});

    // ✅ Submit handler
    const handleSubmit = async (e) => {
        e.preventDefault();

        // ✅ Prepare payload in snake_case for backend
        const payload = {
            patient_id: formData.patientId || null,
            case_id: formData.caseId || null,
            type_id: formData.type_id || null, // ✅ NEW: Include type_id
            progress_notes: formData.progressNotes.map((note) => ({
                date: note.date,
                note: note.note,
            })),
        };

        console.log("Submitting payload:", payload);

        try {
            const result = await dispatch(createProgressNote(payload)).unwrap();

            Swal.fire({
                title: "Success!",
                text: "Progress Note added successfully.",
                icon: "success",
                timer: 2000,
                showConfirmButton: false,
            });

            navigate(`/cases/${payload.case_id}/profile`, {
                state: { patientId: payload.patient_id, caseId: payload.case_id }
            });
        } catch (error) {
            console.error("API Error:", error);

            // ✅ Laravel validation error format handling
            if (error.errors) {
                const flattened = Object.entries(error.errors).reduce(
                    (acc, [key, val]) => ({
                        ...acc,
                        [key]: Array.isArray(val) ? val.join(", ") : val,
                    }),
                    {}
                );
                setErrors(flattened);
            } else {
                Swal.fire("Error", "Something went wrong.", "error");
            }
        }
    };

    return (
        <MainLayout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <div className="card">
                    <div className="card-body">
                        {/* Display type indicator */}
                        {type_id && (
                            <div className="alert alert-info mb-3">
                                <i className="ri-information-line me-2"></i>
                                <strong>Note Type:</strong> {type_id === 1 ? "Psychiatric" : type_id === 4 ? "PRPS" : "Standard"}
                            </div>
                        )}

                        {/* ✅ Display validation errors safely */}
                        {Object.keys(errors).length > 0 && (
                            <div className="alert alert-danger">
                                {Object.entries(errors).map(([key, msg], i) => (
                                    <div key={i}>
                                        <strong>{key.replace(/\.\d+\./, " → ")}:</strong> {msg}
                                    </div>
                                ))}
                            </div>
                        )}

                        <form onSubmit={handleSubmit}>
                            <ProgressNoteForm
                                formData={formData}
                                setFormData={setFormData}
                                typeId={type_id} // ✅ Pass type_id to form component
                            />
                            <div className="col-12 d-flex justify-content-end mt-4">
                                <div className="col-md-2 me-2">
                                    <button
                                        type="button"
                                        className="btn btn-outline-secondary w-100"
                                        onClick={() => navigate(`/cases/${caseId}/profile`, {
                                            state: { patientId, caseId }
                                        })}
                                        disabled={isLoading}
                                    >
                                        <i className="ri-arrow-left-line me-1"></i> Cancel
                                    </button>
                                </div>
                                <div className="col-md-2">
                                    <button
                                        type="submit"
                                        className="btn btn-primary w-100"
                                        disabled={isLoading}
                                    >
                                        {isLoading ? (
                                            <>
                                                <i className="ri-loader-4-line me-1 animate-spin"></i> Saving...
                                            </>
                                        ) : (
                                            <>
                                                <i className="ri-save-2-line me-1"></i> Save
                                            </>
                                        )}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default AddProgressNote;